import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const CallToActionButton = styled.a`
  display: flex;
  align-items: center;
  color: ${globals.THEME.statusWarningText};
  font-weight: 800;
  &:hover {
    color: light-dark(${globals.SIENNA_500}, ${globals.SIENNA_400});
  }
`;

export const IconWrapper = styled.div`
  font-size: 24px;
`;
